import { Outlet, createFileRoute } from '@tanstack/react-router';

import Logs from 'component/view/SiteDetails/Logs';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/logs')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.logs(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: LogsLayout,
});

function LogsLayout() {
  return (
    <Logs>
      <Outlet />
    </Logs>
  );
}
